(function(angular){
    'use strict';

    function CardButtonController() {}

    angular
        .module('MW.Influencers.CardButton', [])
        .component('mwCardButton', {
            bindings: {
                title: '<',
                imageClass: '@',
                text: '<'
            },
            controller: [CardButtonController],
            template: `
                <md-card class='card-button'>
                    <md-card-title class='card-title'>
                        {{$ctrl.title}}
                    </md-card-title>
                    <md-card-content>
                        <div flex layout='row' layout-align='center center' class='card-image-container'>
                            <div class='{{$ctrl.imageClass}}'></div>
                        </div>
                        <div class='text-content'>{{$ctrl.text}}</div>
                    </md-card-content>
                </md-card>
            `
        });
})(angular);